import { db } from "../../common/config/Firebase"
import { MENSUAL, NO_CREATION, TRIMESTRAL, ANUAL } from "./config"
import BusEvent from "common/services/BusEvent"

const invoicesCreationCollection = db.collection('invoicesCreation')
const invoicesCollection = db.collection('invoices')
const invoicesDetailCollection = db.collection('invoiceDetail')

const createInvoiceRecurrent = async () => {
    const invoicesCreation = await invoicesCreationCollection.get()
    for (const invoiceCreationResponse of invoicesCreation.docs) {
        const invoiceCreation = invoiceCreationResponse.data()
        if (isCreationRequired(invoiceCreation)) {
            let invoice = await findInvoiceById(invoiceCreation.invoiceId)
            let invoiceDetail = await findInvoiceDetailById(invoiceCreation.invoiceId)

            invoice = {
                ...invoice,
                isPrincipal: false,
                autogenerated: true,
                invoicePrincipalId: invoice.id,
                payed: 0,
            }
            const invoiceId = await addInvoice(invoice, invoiceCreation.lastDate.toDate())
            await addInvoiceDetail(invoiceId, invoiceDetail)
            await invoicesCreationCollection.doc(invoiceCreationResponse.id).update({
                lastDate: new Date()
            })

            BusEvent.publish(BusEvent.NEW_INVOICE, { ...invoice, id: invoiceId, payed: 0 })
        }
    }
}

const findInvoiceById = async (id) => {
    const invoice = await invoicesCollection.doc(id).get()
    return invoice.data()
}

const findInvoiceDetailById = async (id) => {
    const invoiceDetail = await invoicesDetailCollection.doc(id).get()
    return invoiceDetail.data()
}

const isCreationRequired = (invoiceCreation) => {
    const { lastDate: lastDateFirebase, typeCreation } = invoiceCreation
    if (typeCreation === NO_CREATION) return false;

    const lastDate = lastDateFirebase.toDate();
    const today = new Date();

    const totalMonthsLast = lastDate.getFullYear() * 12 + lastDate.getMonth();
    const totalMonthsToday = today.getFullYear() * 12 + today.getMonth();
    const diffMonths = totalMonthsToday - totalMonthsLast;

    const hasPassedDay = today.getDate() >= lastDate.getDate();
    const monthsPassed = hasPassedDay ? diffMonths : diffMonths - 1;

    switch (typeCreation) {
        case MENSUAL:
            return monthsPassed >= 1;
        case TRIMESTRAL:
            return monthsPassed >= 3;
        case ANUAL:
            return monthsPassed >= 12;
        default:
            return false;
    }
}

const addInvoice = async (invoice, lastDateCreation) => {
    const newDate = new Date(lastDateCreation);
    newDate.setMonth(lastDateCreation.getMonth() + 1);
    const invoiceResponse = await invoicesCollection.add({
        ...invoice,
        invoiceDate: newDate.getTime(),
        payed: 0,
    })
    return invoiceResponse.id
}

const addInvoiceDetail = async (id, invoiceDetail) => {
    await invoicesDetailCollection.doc(id).set(invoiceDetail || {})
}

export default createInvoiceRecurrent